import styled from 'styled-components';

import {smallRegular} from '~/shared/theme/typography';

export const NewTag = styled.span`
  ${smallRegular}
  display: block;
  background-color: ${({theme}) => theme.colors.feedbackPositive};
  color: ${({theme}) => theme.colors.contentPositive};
  border-radius: 4px;
  padding: 0 6px;
`;
